import React from "react";
import { useContext } from "react";
import { Box, Typography, Button,CardMedia,Grid,Divider} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import Footer from "./layout/Footer"
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LockIcon from "@mui/icons-material/Lock";
import { Autoplay,Pagination,EffectFade } from "swiper/modules";
import "swiper/css";
import { Chip } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import "swiper/css/pagination";
import Navbar from "./layout/Navbar";
import HomepageContext from "./context/HomepageContext";
import { useNavigate } from "react-router-dom";
import "swiper/css/effect-fade"; // Import fade effect CSS



const banners = [
  { id: 1, image: "https://en.ohmycream.com/cdn/shop/files/2025_01_OMC0260_DERMALOGICA_0_Home_88d58b3d-deca-4a20-8147-36250c5899f1_1000x.jpg?v=1739453315" },
  { id: 2, image: "https://en.ohmycream.com/cdn/shop/files/2025_02_GOODIEBAG_Home_1000x.jpg?v=1738746735" },
  { id: 3, image: "https://en.ohmycream.com/cdn/shop/files/2025_01_OMC0260_DERMALOGICA_0_Home_88d58b3d-deca-4a20-8147-36250c5899f1_1000x.jpg?v=1739453315" },
];



const rightImages = [
  "https://en.ohmycream.com/cdn/shop/collections/05_22_Collection_Marque_Post_Talm_TINY_700x.jpg?v=1651828972",
  "https://img.freepik.com/free-photo/view-male-beauty-products-with-rock-stone-display_23-2150435221.jpg?semt=ais_hybrid",

];


const Homepage = () => {
 
    const services = [
      { icon: <LocalShippingIcon />, label: "Fast Delivery" },
      { icon: <SupportAgentIcon />, label: "24/7 Support" },
      { icon: <LockIcon />, label: "Secure Payment" },
      { icon: <LockIcon />, label: "Flash Sale" },
    ];
 
  const navigate = useNavigate();
  const { products,bestsell } = useContext(HomepageContext); // ✅ Access products from context
  const handleProductClick = (product) => {
    sessionStorage.setItem("productData", JSON.stringify(product)); // Store product details
    navigate(`/product/${product.ProdtID}`, { state: product }); // Navigate to product details page
  };
  
  return (
    <>
      <Navbar />
      <Box sx={{ width: "1200px", margin: "auto", display: "flex", gap: 2, mt: 1, }}>
       

        {/* Center - Carousel */}
        <Box sx={{ width: "60%", position: 'relative' }}>
  <Swiper
    modules={[Autoplay,Pagination, EffectFade]}
    spaceBetween={10}
    slidesPerView={1}
    loop={true}
    pagination={{ clickable: true }}
    effect="fade"
    fadeEffect={{ crossFade: true }}
    autoplay={{
      delay: 4000, // Auto-slide every 3 seconds
      disableOnInteraction: false, // Prevent pausing when user interacts
    }}
    style={{ width: "100%", height: "100%", borderRadius: "5px" }}
  >
    {banners.map((banner) => (
      <SwiperSlide key={banner.id}>
        <Box
          sx={{
            width: "100%",
            height: "420px",
            backgroundImage: `url(${banner.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "5px",
            position: 'relative',
            overflow: 'hidden',
            '&:hover .overlay-content': {
              opacity: 1,
              transform: 'translateY(0)'
            }
          }}
        >
          {/* Gradient Overlay with Animation */}
          <Box sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '60%',
            background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)',
            opacity: 0,
            animation: 'fadeIn 0.5s ease-out forwards',
            '@keyframes fadeIn': {
              '0%': { opacity: 0 },
              '100%': { opacity: 1 }
            }
          }} />

          {/* Text Content with Staggered Animations */}
          <Box className="overlay-content" sx={{
            position: 'absolute',
            bottom: 40,
            left: 30,
            color: 'white',
            zIndex: 2,
            maxWidth: '60%',
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
          }}>
            <Typography variant="h3" sx={{ 
              fontWeight: 700,
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              mb: 1,
              animation: 'slideInUp 0.6s ease-out 0.3s forwards',
              '@keyframes slideInUp': {
                '0%': { opacity: 0, transform: 'translateY(30px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' }
              }
            }}>
              {banner.title}
            </Typography>
            <Typography variant="body1" sx={{ 
              fontSize: '1.2rem',
              mb: 2,
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
              animation: 'slideInUp 0.6s ease-out 0.5s forwards',
              opacity: 0
            }}>
              {banner.subtitle}
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              sx={{
                borderRadius: '25px',
                px: 4,
                py: 1.5,
                fontWeight: 700,
                boxShadow: 3,
                transform: 'scale(0.9)',
                animation: 'popIn 0.4s ease-out 0.7s forwards',
                '@keyframes popIn': {
                  '0%': { opacity: 0, transform: 'scale(0.8)' },
                  '80%': { transform: 'scale(1.05)' },
                  '100%': { opacity: 1, transform: 'scale(1)' }
                },
                '&:hover': {
                  transform: 'translateY(-2px) scale(1.02)'
                }
              }}
            >
              Shop Collection
            </Button>
          </Box>

          {/* Animated Product Tags */}
          <Box sx={{
            position: 'absolute',
            top: 20,
            right: 20,
            display: 'flex',
            gap: 1.5,
            zIndex: 2,
            '& .MuiChip-root': {
              animation: 'slideInRight 0.5s ease-out forwards',
              opacity: 0,
              transform: 'translateX(20px)'
            },
            '& .MuiChip-root:nth-of-type(1)': { animationDelay: '0.4s' },
            '& .MuiChip-root:nth-of-type(2)': { animationDelay: '0.6s' },
            '@keyframes slideInRight': {
              '0%': { opacity: 0, transform: 'translateX(20px)' },
              '100%': { opacity: 1, transform: 'translateX(0)' }
            }
          }}>
            <Chip label="New Arrival" sx={{  background: 'rgba(255,255,255,0.9)',
                fontWeight: 700,
                backdropFilter: 'blur(4px)' }} />
            <Chip label="30% Off" sx={{ background: 'rgba(255,50,50,0.9)',
                color: 'white',
                fontWeight: 700,
                backdropFilter: 'blur(4px)' }} />
          </Box>
        </Box>
      </SwiperSlide>
    ))}
  </Swiper>

  {/* Animated Social Proof */}
  <Box sx={{
    position: 'absolute',
    bottom: 20,
    right: 20,
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    bgcolor: 'rgba(255,255,255,0.9)',
    px: 2,
    py: 1,
    borderRadius: '8px',
    backdropFilter: 'blur(4px)',
    boxShadow: 1,
    animation: 'slideInUp 0.6s ease-out 1s forwards',
    opacity: 0,
    transform: 'translateY(20px)',
    '@keyframes slideInUp': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    }
  }}>
    <FavoriteIcon color="error" sx={{ mr: 1 }} />
    <Typography variant="body2">
      <strong>1.2k</strong> people are viewing this
    </Typography>
  </Box>
</Box>

        {/* Right Side - 3 Images */}
        <Box sx={{ width: "25%", display: "flex", flexDirection: "column", gap: 2 }}>
          {rightImages.map((img, index) => (
            <CardMedia key={index} component="img" image={img} sx={{ borderRadius: "5px",height:"200px",objectFit:"fill" }} />
          ))}
          
        </Box>

        <Box sx={{ width: "10%", display: "flex", flexDirection: "column", gap: 1 }}>
 
 
  {/* <VerticalMarquee items={liveUpdates} /> */}
  {services.map((service, index) => (
        <Box key={index} textAlign="center">
          <Box sx={{ fontSize: 40, color: "#1E7CB7" }}>{service.icon}</Box>
          <Typography fontSize="14px" fontWeight="bold">{service.label}</Typography>
          <Divider />
        </Box>
      ))}
</Box>



      </Box>


      <Box sx={{ 
  px: { xs: 2, md: 6 },  // Equal horizontal padding
  py: 6,
  width: '100%',  // Ensure full width
  boxSizing: 'border-box'  // Include padding in width calculation
}}>
  <Grid container justifyContent="center">  
    <Grid item xs={12} sx={{ 
      maxWidth: '1440px',  // Set max-width for better control

    }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 4 ,
        px: { xs: 2, md: 0 }
      }}>
        <Typography variant="h3" sx={{ 
          fontSize: "1.5rem",
          fontWeight: 700,
          color: '#1E7CB7',
          position: 'relative',
          '&:after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            left: 0,
            width: '60px',
            height: '3px',
            backgroundColor: '#2FA8EF',
            borderRadius: '2px'
          }
        }}>
          Featured Products
        </Typography>
        <Button variant="outlined" sx={{
          borderColor: '#1E7CB7',
          color: '#1E7CB7',
          '&:hover': {
            backgroundColor: '#1E7CB7',
            borderColor: '#2a604a',
            color:"#fff"
          },
          borderRadius: '20px',
          textTransform: 'none',
          px: 4
        }}>
          View All
        </Button>
      </Box>
    </Grid>

    {/* Product Grid */}
    <Grid container spacing={4}>
      {products.map((product, index) => (
        <Grid item key={index} xs={12} sm={6} md={3} lg={3}>
          <Box sx={{
            p: 2,
            borderRadius: "12px",
            backgroundColor: "#fff",
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            position: "relative",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            overflow: 'hidden',
            '&:hover': { 
              transform: "translateY(-4px)",
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              '& .product-image': {
                transform: 'scale(1.05)'
              }
            },
          }}>
            {/* Discount Badge */}
            {product.ProductPercentage && (
              <Box sx={{
                position: 'absolute',
                top: 12,
                left: 12,
                backgroundColor: '#2FA8EF',
                color: 'white',
                px: 1.5,
                py: 0.5,
                borderRadius: '4px',
                fontSize: '0.75rem',
                fontWeight: 700,
                zIndex: 2
              }}>
                {product.ProductPercentage}% OFF
              </Box>
            )}

            {/* Product Image */}
            <Box 
              onClick={() => handleProductClick(product)} 
              sx={{ 
                width: "100%", 
                height: "200px", 
                position: 'relative',
                overflow: "hidden", 
                borderRadius: "8px",
                // backgroundColor: "#f8f8f8",
                cursor: "pointer",
                '&:hover .image-overlay': {
                  opacity: 1
                }
              }}
            >
              <img 
                src={product.ProdImage} 
                alt={product.ProdName} 
                className="product-image"
                style={{ 
                  width: "100%", 
                  height: "100%", 
                  objectFit: "contain",
                  transition: 'transform 0.3s ease' 
                }} 
              />
              <Box className="image-overlay" sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(180deg, rgba(54,121,90,0) 60%, rgba(54,121,90,0.15) 100%)',
                opacity: 0,
                transition: 'opacity 0.3s ease'
              }} />
            </Box>

            {/* Product Info */}
            <Box sx={{ pt: 2 }}>
              <Typography 
                variant="h6" 
                sx={{
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  color: '#333',
                  lineHeight: 1.3,
                  mb: 1,
                  cursor: "pointer",
                  '&:hover': { color: '#2FA8EF' }
                }}
                onClick={() => handleProductClick(product)}
              >
                {product.ProdName}
              </Typography>

              {/* Price Section */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1.5,
                mt: 1
              }}>
                <Typography sx={{ 
                  fontSize: "1rem",
                  fontWeight: 700,
                  color: '#1E7CB7'
                }}>
                  NPR {product.ProdRetailPrice}
                </Typography>
                {product.ProdMrpPrice && (
                  <Typography sx={{
                    fontSize: "0.875rem",
                    color: "text.secondary",
                    textDecoration: "line-through"
                  }}>
                    NPR {product.ProdMrpPrice}
                  </Typography>
                )}
              </Box>

              {/* Action Buttons */}
              <Box sx={{ 
                display: 'flex', 
                gap: 1, 
                mt: 2,
                opacity: 1,
                transition: 'opacity 0.3s ease'
              }}>
                {/* <Button 
                  variant="contained" 
                  size="small"
                  sx={{
                    backgroundColor: '#2FA8EF',
                    color: 'white',
                    borderRadius: '6px',
                    px: 2,
                    py: 1,
                    fontSize: '0.75rem',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: '#7aa738'
                    }
                  }}
                >
                  Add to Cart
                </Button> */}
                <Button 
                  variant="outlined" 
                  size="small"
                  onClick={() => handleProductClick(product)}
                  sx={{
                    borderColor: '#ddd',
                    color: '#555',
                    borderRadius: '6px',
                    px: 2,
                    py: 1,
                    fontSize: '0.75rem',
                    textTransform: 'none',
                    '&:hover': {
                      borderColor: '#2FA8EF',
                      color: '#2FA8EF'
                    }
                  }}
                >
                  Quick View
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Grid>
</Box>



<Footer />


      {/* Swiper Pagination Custom Styling */}
      <style>
        {`
          .swiper-pagination-bullet {
            background: white !important;  /* Change bullet color to white */
          }
        `}
      </style>
    </>
  );
};

export default Homepage;
